/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const postApiTestMarkTracksQueryParamsSchema = z.object({
    "Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Успешно
 */
export const postApiTestMarkTracks200Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const postApiTestMarkTracks400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiTestMarkTracks401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiTestMarkTracks403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiTestMarkTracks500Schema = z.lazy(() => badResponseModelSchema)

export const postApiTestMarkTracksMutationResponseSchema = z.lazy(() => postApiTestMarkTracks200Schema)